export default __webpack_public_path__ + "static/media/laced.74772d80.png";